const send = (targetWindow, message) => {
  if (window === window.parent) return;

  targetWindow.postMessage(JSON.stringify(message), '*');
};

const listen = (sourceWindow, messageHandler) => {
  if (window === window.parent) return;

  sourceWindow.addEventListener(
    'message',
    (postResponse) => {
      let message;

      /**
       * Third party libraries can use `postMessage` and it may cause errors.
       * */
      try {
        message = JSON.parse(postResponse.data);
      } catch (e) {
        return;
      }

      messageHandler(message);
    },
    false
  );
};

export default {
  send,
  listen,
};
